const urlStart = 'https://srengseng-backend-2.smartclaimsystem.com';
const baseImage = 'https://srengseng-backend-2.smartclaimsystem.com/api/image';
//const urlStart = 'https://backend.autoprima.co.id';
//const baseImage = 'https://backend.autoprima.co.id';
const productionMode = true;
const awsImageUploader = '';

const workorderOptions = {
    allowTutupWoStepBengkel : false // Kalo Tutup Work Order Tidak Ad Kondisi Step Bengkel Hrus Semua Selesai , Set ini True
}


export default {productionMode , urlStart, baseImage : baseImage ? baseImage : urlStart , awsImageUploader, workorderOptions};
